/* ezItemizer brand mark — official full logo (icon + wordmark + tagline on
 * navy rounded-square background).
 *
 * Drop-in replacement for the previous component. Because the full logo
 * already includes the "ezItemizer" wordmark, adjacent text labels have
 * been removed at each call site to avoid duplication.
 *
 * Color props are no-ops (the official logo has its own palette baked in);
 * layout classes on `className` are still forwarded to the <img>.
 */
export default function BrandMark({ size = 24, className = "" }) {
  return (
    <img
      src="/logo-ezitemizer.png"
      width={size}
      height={size}
      alt="ezItemizer · Scan. Track. Simplify."
      className={className}
      style={{ display: "inline-block", objectFit: "contain" }}
      draggable={false}
    />
  );
}
